module.exports = __webpack_public_path__ + "img/img_person1_232px@3x.6506cb8f.png";